import React, { useState } from 'react';
import { useNotify, useTranslate, useUpdate } from 'react-admin';
import {
    Button,
    createStyles,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    makeStyles,
    MenuItem,
    Select,
    TextField,
    Theme,
} from '@material-ui/core';
import { OrderStatus } from '../../constants';
import { Order } from '../../types';
import { useGetList } from 'react-admin';
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        formControl: {
            margin: theme.spacing(1),
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
    })
);
type Props = {
    record: Order;
};

const CancelButton: React.FC<Props> = ({ record }) => {
    const notify = useNotify();
    const classes = useStyles();

    const translate = useTranslate();
    const [isOpen, setIsOpen] = useState(false);
    const [reason, setReason] = useState('');
    const [comment, setComment] = useState('');
    const { ids, data, total, loaded } = useGetList(
        'cancel-reasons',
        {},
        { field: 'id', order: 'DESC' },
        {}
    );
    const [cancelOrder, { loading }] = useUpdate(
        'orders',
        record.id,
        {
            status: OrderStatus.cancelled,
            cancelReasonId: reason,
            reason: comment,
        },
        record,
        {
            undoable: false,
            onSuccess: () => {
                notify(
                    'resources.orders.notification.cancelled_success',
                    'info'
                );
            },
            onFailure: () => {
                notify(
                    'resources.orders.notification.cancelled_error',
                    'warning'
                );
            },
        }
    );

    // const handleReasonChange = event => {
    //     setReason(event.target.value.trim());
    // };
    const handleReasonChange = event => {
        const selectedReason = event.target.value;
        console.log('Selected Reason:', selectedReason); // Debugging line
        setReason(selectedReason);
    };
    const handleCommentChange = event => {
        setComment(event.target.value);
    };
    return (
        <>
            <Button
                variant="contained"
                color="secondary"
                size="small"
                disabled={loading}
                onClick={() => setIsOpen(true)}
            >
                {translate('action.cancel')}
            </Button>

            <Dialog
                fullWidth={true}
                maxWidth="sm"
                open={isOpen}
                onClose={() => setIsOpen(false)}
            >
                <DialogTitle>
                    {translate('resources.orders.action.cancel')}
                </DialogTitle>

                <DialogContent style={{ overflowX: 'hidden' }}>
                    {/* <TextField
                        autoFocus
                        margin="dense"
                        id="reason"
                        label={translate('fields.reason')}
                        multiline
                        required
                        fullWidth
                        variant="outlined"
                        onChange={handleReasonChange}
                    /> */}
                    <FormControl
                        variant="outlined"
                        fullWidth
                        className={classes.formControl}
                    >
                        <InputLabel id="select-assigneeId-label">
                            {translate('fields.reason')}
                        </InputLabel>
                        <Select
                            labelId="select-assigneeId-label"
                            id="select-assigneeId"
                            autoFocus
                            required
                            onChange={handleReasonChange}
                            label={translate('fields.reason')}
                        >
                            {(ids || []).map(id => (
                                <MenuItem key={id} value={id}>
                                    {data[id].reason}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl
                        variant="outlined"
                        fullWidth
                        className={classes.formControl}
                    >
                        <TextField
                            onChange={handleCommentChange}
                            label="Comment"
                            inputProps={{
                                maxLength: 200,
                            }}
                        />
                    </FormControl>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setIsOpen(false)}>
                        {translate('action.close')}
                    </Button>

                    <Button
                        variant="contained"
                        color="secondary"
                        disabled={loading || reason === ''}
                        onClick={() => {
                            cancelOrder();
                            setIsOpen(false);
                        }}
                    >
                        {translate('resources.orders.action.cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default CancelButton;
